export default function SearchBar({ value = null, search = true, placeholder = 'Start searching', onClick = () => {}, onChange = () => {} }) {
    let clearOut = null;

    const handleChange = (e) => {
        e.persist();

        clearTimeout(clearOut);

        clearOut = setTimeout(() => {
            onChange(e);
        }, 500)
    }

    let props = {}

    if (value === null) props.value = value;

    return (
        <div className={`search-bar`}>
            <input className="search-bar__input" { ...props } placeholder={placeholder} onChange={handleChange}/>
            { search && <button className="search-bar__button" onClick={onClick}>Search</button> }
        </div>
    )
}
